import {RailsPdtConstants} from './RailsPdtConstants';
import RailsPdtListingEvent from '../PdtModel/PdtEvents/RailsPdtListingEvent';
import {pushPdtData} from '../PdtAnalytics';

export default class RailsPdtListingHelper {
  static trackPageLoad(data, dataType) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.LOAD_PAGE;
      const pdtObject = new RailsPdtListingEvent(pdtData, dataType).trackListingEvent();
      pdtObject.user_flow_blocker.blocking_reason = data?.listingErrorCodeString;
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackPageExit(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.EXIT_PAGE;
      const pdtObject = new RailsPdtListingEvent(pdtData).trackListingEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackBackPressed(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.CLICK_BACK;
      const pdtObject = new RailsPdtListingEvent(pdtData).trackListingEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackTrainClicked(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.ListingEventAction.CLICK_TRAIN;
      const pdtObject = new RailsPdtListingEvent(pdtData).trackListingEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }
}
